import { LobbyScene } from "./../LobbyScene";
import { MapLayer } from "./MapLayer";
import { GameVars } from "../../../GameVars";
import { GameConstants } from "../../../GameConstants";
import { AudioManager } from "../../../AudioManager";
import { King } from "./King";

export class MapsLayer extends Phaser.GameObjects.Container {

    public maps: MapLayer[];
    public leftButton: Phaser.GameObjects.Image;
    public rightButton: Phaser.GameObjects.Image;
    public bckContainer: Phaser.GameObjects.Container;

    public currentPosition: number;

    private king: King;
    private tableContainer: Phaser.GameObjects.Container;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.x = 280 * GameVars.scaleX + (GameConstants.GAME_WIDTH - 280 * GameVars.scaleX) / 2;

        if (!this.scene.sys.game.device.os.desktop) {
            this.scaleX = GameVars.scaleX;
        }

        this.bckContainer = new Phaser.GameObjects.Container(this.scene);
        this.bckContainer.y = GameConstants.GAME_HEIGHT;
        this.add(this.bckContainer);

        let bck = new Phaser.GameObjects.Image(this.scene, 20, 0, "texture_atlas_5", "table_background_01");
        bck.setOrigin(.5, 1);
        this.bckContainer.add(bck);

        bck = new Phaser.GameObjects.Image(this.scene, -bck.width + 20, 0, "texture_atlas_5", "table_background_01");
        bck.setOrigin(.5, 1);
        this.bckContainer.add(bck);

        bck = new Phaser.GameObjects.Image(this.scene, bck.width + 20, 0, "texture_atlas_5", "table_background_01");
        bck.setOrigin(.5, 1);
        this.bckContainer.add(bck);

        let man1 = new Phaser.GameObjects.Image(this.scene, -360, -340, "texture_atlas_5", "table_background_02");
        man1.setOrigin(.5, 1);
        this.bckContainer.add(man1);

        let man2 = new Phaser.GameObjects.Image(this.scene, 380, -290, "texture_atlas_5", "table_background_03");
        man2.setOrigin(.5, 1);
        this.bckContainer.add(man2);

        this.tableContainer = new Phaser.GameObjects.Container(this.scene);
        this.tableContainer.y = GameConstants.GAME_HEIGHT;
        this.add(this.tableContainer);

        let table = new Phaser.GameObjects.Image(this.scene, -1, GameConstants.GAME_HEIGHT, "texture_atlas_5", "table_background_08");
        table.setOrigin(.5, 1);
        this.add(table);

        table = new Phaser.GameObjects.Image(this.scene, 1, GameConstants.GAME_HEIGHT, "texture_atlas_5", "table_background_08");
        table.setOrigin(.5, 1);
        table.scaleX = -1;
        this.add(table);

        this.currentPosition = 0;

        this.maps = [];

        for (let i = 0; i < GameVars.gameData.progression.length; i++) {
            const mapLayer = new MapLayer(this.scene, i);
            this.add(mapLayer);
            this.maps.push(mapLayer);

            if (GameVars.gameData.progression[i].completed && i !== GameVars.gameData.progression.length - 1) {
                this.currentPosition++;
            }
        }

        this.king = new King(this.scene, this);
        this.add(this.king);

        this.leftButton = new Phaser.GameObjects.Image(this.scene, -320 / GameVars.scaleX, 630, "texture_atlas_1", "btn_scroll");
        this.leftButton.setInteractive();
        this.leftButton.scaleX = -1;
        this.leftButton.on("pointerdown", this.onClickLeft, this);
        this.leftButton.on("pointerout", function () {
            this.leftButton.setScale(-1, 1);
        }, this);
        this.leftButton.on("pointerover", function () {
            this.leftButton.setScale(-1.05, 1.05);
        }, this);
        this.add(this.leftButton);

        this.rightButton = new Phaser.GameObjects.Image(this.scene, 320 / GameVars.scaleX, 630, "texture_atlas_1", "btn_scroll");
        this.rightButton.setInteractive();
        this.rightButton.on("pointerdown", this.onClickRight, this);
        this.rightButton.on("pointerout", function () {
            this.rightButton.setScale(1);
        }, this);
        this.rightButton.on("pointerover", function () {
            this.rightButton.setScale(1.05);
        }, this);
        this.add(this.rightButton);

        if (this.currentPosition === 0) {
            this.leftButton.visible = false;
        } else if (this.currentPosition === GameVars.gameData.progression.length - 1) {
            this.rightButton.visible = false;
        }

        this.maps[this.currentPosition].visible = true;

    }

    public kingHitTable(): void {

        this.king.setHead();
        this.scene.time.addEvent({ delay: 500, callback: () => {
            this.king.hitTable();
        }, callbackScope: this});
        
    }

    public shakeTable(): void {

        this.scene.tweens.add({
            targets: [this.tableContainer, this.maps[this.currentPosition]],
            y: this.tableContainer.y + 5,
            ease: Phaser.Math.Easing.Elastic.InOut,
            duration: 100,
            yoyo: true
        });

        this.maps[this.currentPosition].shake();
    }

    public showLevelCompleted(): void {

        this.maps[GameVars.levelCompleted.zone].showLevelCompleted();
    }

    public unlockNextLevel(): void {

        if (GameVars.levelCompleted.map === 5 && GameVars.levelCompleted.zone !== 4) {
            this.maps[GameVars.levelCompleted.zone + 1].unlockNextLevel();
            this.maps[this.currentPosition].visible = false;
            this.currentPosition--;
            this.maps[this.currentPosition].visible = true;
            LobbyScene.currentInstance.scrollBack();
            this.scene.time.addEvent({ delay: 2000, callback: () => {
                this.onClickRight();
            }, callbackScope: this});
        } else if (GameVars.levelCompleted.map < 5) {
            this.maps[GameVars.levelCompleted.zone].unlockNextLevel();
        }
    }

    public onClickLeft(): void {

        if (GameVars.gameData.buyTutorial && !GameVars.gameData.initialTutorial) {
            return;
        }

        AudioManager.playSound("map_slide");

        this.maps[this.currentPosition].hide(true);

        this.currentPosition--;

        this.maps[this.currentPosition].show(true);

        if (this.currentPosition === 0) {
            this.leftButton.visible = false;
        }

        this.rightButton.visible = true;

        LobbyScene.currentInstance.scrollBackground((-220 - 50 / GameVars.scaleX) * this.currentPosition);
        
        this.scene.tweens.add({
            targets: this.bckContainer,
            x: -8 * this.currentPosition,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 1000
        });
    }

    public onClickRight(): void {

        if (GameVars.gameData.buyTutorial && !GameVars.gameData.initialTutorial) {
            return;
        }

        AudioManager.playSound("map_slide");

        this.maps[this.currentPosition].hide();

        this.currentPosition++;

        this.maps[this.currentPosition].show();

        if (this.currentPosition === GameVars.gameData.progression.length - 1) {
            this.rightButton.visible = false;
        }

        this.leftButton.visible = true;

        LobbyScene.currentInstance.scrollBackground((-220 - 50 / GameVars.scaleX) * this.currentPosition);

        this.scene.tweens.add({
            targets: this.bckContainer,
            x: -8 * this.currentPosition,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 1000
        });
    }
}
